import { render, staticRenderFns } from "./page-unload-alert.vue?vue&type=template&id=74504d7c&scoped=true&"
import script from "./page-unload-alert.vue?vue&type=script&lang=js&"
export * from "./page-unload-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74504d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74504d7c')) {
      api.createRecord('74504d7c', component.options)
    } else {
      api.reload('74504d7c', component.options)
    }
    module.hot.accept("./page-unload-alert.vue?vue&type=template&id=74504d7c&scoped=true&", function () {
      api.rerender('74504d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/page-unload-alert/page-unload-alert.vue"
export default component.exports